<template>
  <div class="operatorAPI_page" style="height: 100%">
    <div class="card_add form-group">
    </div>
    <div class="operators_list">
      <OperatorsAPIItem
        v-for="(operator,key) in operators"
        :key="key"
        class="operator-item"
        :operator="operator"
      />
    </div>
  </div>
</template>

<script>
import OperatorsAPIItem from './Item/Index.vue'
export default {
  name: 'OperatorsAPI',
  components: {
    OperatorsAPIItem
  },
  data () {
    return {
      operators: {}
    }
  },
  mounted () {
    this.$http.simcard.getOperatorsAPI((response) => {
      this.operators = response.data
    })
  },
}
</script>

<style lang="scss" scoped>
  .operatorAPI_page{
    padding: 10px;
  }
  .card_add{
    margin-bottom: 15px;
  }
  .operators_list{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    .operator-item{
      width: 25%;
      padding: 10px;
    }
  }

  @media (max-width: 1366px){
    .operators_list{
      .operator-item{
        width: 33%;
      }
    }
  }
  @media (max-width: 768px){
    .operators_list{
      .operator-item{
        width: 50%;
      }
    }
  }
  @media (max-width: 500px){
    .operators_list{
      .operator-item{
        width: 100%;
      }
    }
  }
</style>
